export default {
	all_yout_user_data_will_be_deleted_and_this_process_isnt_reversible:
		'¡TODOS TUS DATOS SERÁN ELIMINADOS, PROCESO IRREVERSIBLE!',
	check_in_on_a_event: 'participar en un evento',
	commented_the_news: 'comentó la noticia ',
	earned_a_certification_on_the_trail: 'recibió un certificado por la trayectoria ',
	earned_a_certification_on_the_training: 'recibió un certificado de entrenamiento',
	earned_the_badge: 'recibió la insignia',
	evaluated_the_podcast: 'evaluó el podcast',
	evaluated_the_trail: 'evaluó la trayectoria ',
	evaluated_the_training: 'evaluó el entrenamiento',
	extra_activity: 'actividad extra',
	favorited_the_podcast: 'le dió "favorito" al podcast',
	favorited_the_trail: 'le dió "favorita" a la trayectoria ',
	favorited_the_training: 'le dió "favorito" al entrenamiento',
	i_do_confirm_the_deletion_of_my_user_data: 'CONFIRMAR ELIMINACIÓN DE CUENTA',
	liked_the_podcast: 'le dió "me gusta" al podcast',
	liked_the_trail: 'le dió "me gusta" a la trayectoria',
	liked_the_training: 'le dió "me gusta" al entrenamiento',
	liked_the_live_class: 'le dió "me gusta" al clase en vivo',
	evaluated_the_live_class: 'evaluó el clase en vivo',
	liked_the_presential_event: 'le dió "me gusta" a al evento presencial',
	evaluated_the_presential_event: 'evaluated el evento presencial',
	new_sale_informed: 'nueva venta informada',
	points_were_awarded_for: 'Puntos asignados por',
	the_file: 'El archivo',
	the_product: 'El producto',
	the_trail: 'El trayectoria',
	the_training: 'El entrenamiento',
	the_webinar: 'El seminário web',
	there_are_no_activities_at_the_moment: 'No hay actividades en el momento',
	close_account: 'Solicitar eliminación',
	training_finished_on_irep: 'entrenamiento completado en el Programa Intel® Retail Edge',
	upgrading_to_level: 'actualizar a nivel',
	was_published_f: 'fue publicada',
	was_published_on_the_library: 'fue publicado en la biblioteca',
	was_published: 'fue publicado',
	was_purchased: 'fue adquirido',
	to_confirm_enter_your_name: 'Para continuar, ingrese su nombre:',
}
